import { emitAnalyticsEvent, TaggingEventName, ILoyaltyEventData } from '~utils/Analytics';

export class AnalyticalTrackingUseCase {
    private LoyaltyEventData: ILoyaltyEventData;
    private eventTagName: TaggingEventName;

    constructor(LoyaltyEventData: ILoyaltyEventData, eventTagName: TaggingEventName) {
        this.LoyaltyEventData = LoyaltyEventData;
        this.eventTagName = eventTagName;
    }

    public execute = async () => {
        const { event_label, event_name, event_category } = this.LoyaltyEventData;

        if (event_label) {
            const eventData: ILoyaltyEventData = this.LoyaltyEventData;

            eventData.event_name = event_name || 'account_loyalty';
            eventData.event_category = event_category || 'account_loyalty';

            emitAnalyticsEvent(this.eventTagName, eventData);
        }
    };
}